import { ChangeEvent } from 'react';
import FormGroup from '../../../components/FormGroup';
import Input from '../../../components/Input';
import PasswordInputFormGroup from '../../../components/PasswordInputFormGroup';
import { GetErrorMessageByFieldNameType } from '../../../hooks/useErrors';

interface ContactAndAccessInterface {
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  cpf: string;
  handleCpfChange: (event: ChangeEvent<HTMLInputElement>) => void;
  name: string;
  handleNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  contactCellphone: string;
  handleContactCellphoneChange: (event: ChangeEvent<HTMLInputElement>) => void;
  email: string;
  handleEmailChange: (event: ChangeEvent<HTMLInputElement>) => void;
  emailConfirmation: string;
  handleEmailConfirmationChange: (event: ChangeEvent<HTMLInputElement>) => void;
  password: string;
  handlePasswordChange: (event: ChangeEvent<HTMLInputElement>) => void;
  passwordConfirmation: string;
  handlePasswordConfirmationChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export default function ContactAndAccess({
  getErrorMessageByFieldName,
  cpf,
  handleCpfChange,
  name,
  handleNameChange,
  contactCellphone,
  handleContactCellphoneChange,
  email,
  handleEmailChange,
  emailConfirmation,
  handleEmailConfirmationChange,
  password,
  handlePasswordChange,
  passwordConfirmation,
  handlePasswordConfirmationChange,
}: ContactAndAccessInterface) {
  return (
    <div className="dataGroup">
      <div className="title">
      4. Dados de contato e acesso
      </div>

      <div className="aside">
        <div className="loginInput">
          <FormGroup error={getErrorMessageByFieldName('cpf')}>
            <label htmlFor="login">CPF</label>
            <Input
              placeholder="Informe o CPF"
              value={cpf}
              onChange={handleCpfChange}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('cpf')}
              maxLength={14}
            />
          </FormGroup>
        </div>
        <div className="loginInput">
          <FormGroup error={getErrorMessageByFieldName('name')}>
            <label htmlFor="login">Nome</label>
            <Input
              placeholder="Informe o nome do contato"
              value={name}
              onChange={handleNameChange}
              maxLength={25}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('name')}
            />
          </FormGroup>
        </div>
      </div>

      <div className="loginInput">
        <FormGroup error={getErrorMessageByFieldName('contactCellphone')}>
          <label htmlFor="login">Celular</label>
          <Input
            placeholder="Informe o celular do contato"
            value={contactCellphone}
            onChange={handleContactCellphoneChange}
            autoComplete="new-password"
            maxLength={15}
            error={getErrorMessageByFieldName('contactCellphone')}
          />
        </FormGroup>
      </div>

      <div className="aside">
        <div className="loginInput">
          <FormGroup error={getErrorMessageByFieldName('email')}>
            <label htmlFor="login">E-mail</label>
            <Input
              placeholder="Informe seu e-mail"
              value={email}
              onChange={handleEmailChange}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('email')}
            />
          </FormGroup>
        </div>
        <div className="loginInput">
          <FormGroup error={getErrorMessageByFieldName('emailConfirmation')}>
            <label htmlFor="login">Confirmação de e-mail</label>
            <Input
              placeholder="Confirme seu e-mail"
              value={emailConfirmation}
              onChange={handleEmailConfirmationChange}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('emailConfirmation')}
            />
          </FormGroup>
        </div>
      </div>

      <div className="aside">
        <div className="loginInput">
          <PasswordInputFormGroup
            label='Senha'
            value={password}
            onChange={handlePasswordChange}
            error={getErrorMessageByFieldName('password')}
          />
        </div>
        <div className="loginInput">
          <PasswordInputFormGroup
            label='Confirmação de senha'
            value={passwordConfirmation}
            onChange={handlePasswordConfirmationChange}
            error={getErrorMessageByFieldName('passwordConfirmation')}
          />
        </div>
      </div>
    </div>
  );
}
